import React from 'react';
import { Helmet } from 'react-helmet';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import { getConfig } from '@edx/frontend-platform';

import messages from './messages';

function Head({ intl }) {
  return (
    <Helmet>
      <title>
        {intl.formatMessage(messages['account.page.title'], { siteName: getConfig().SITE_NAME })}
      </title>
      <link rel="shortcut icon" href={getConfig().FAVICON_URL} type="image/x-icon" />
      <link rel="stylesheet" href="https://tudelft-public.s3.eu-central-1.amazonaws.com/profed-olive/static/css/main-app-learning.css" type="text/css" />
    </Helmet>
  );
}

Head.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(Head);
